module.exports = __webpack_public_path__ + "static/logo-570336f3489547b651883d0d40a4c648.svg";